import { useEffect } from 'react';

import { isProduction, useAppDispatch } from 'shared/lib';

import { goToNextScenarioThunk } from 'entities/scenario';

export const useDevGoToNext = () => {
  const dispatch = useAppDispatch();
  const isProd = isProduction();

  useEffect(() => {
    if (typeof window !== 'undefined' && !isProd) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).goToNext = (step: any, payload?: any) => {
        dispatch(goToNextScenarioThunk({ step, payload }));
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isProd]);
};
